<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M7,0L2,5v11h12V0H7z M13,15H3V6h5V1h5V15z" />
</svg>
</template>